const t = {
  name: "TwitterSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.5,6l9,12h-2l-9-12H8.5z"/>
		<path class="st0" d="M24,12c0,6.6-5.4,12-12,12C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0C18.6,0,24,5.4,24,12z M10.3,12.7L4.6,19h1.3
			l5.1-5.5L15,19h4.4l-6.1-8.1L18.7,5h-1.3l-4.7,5L9,5H4.6L10.3,12.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as TwitterSmall
};
